import type { RouteObject } from "react-router-dom";

export const aeoDashboardRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "AEO Dashboard" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AeoDashboard } = await import("./aeo-dashboard");
          return { Component: AeoDashboard };
        },
      },
      {
        path: "prompt-tester",
        async lazy() {
          const { AgentPromptTester } = await import("./agent-prompt-tester");
          return { Component: AgentPromptTester };
        },
      },
      {
        path: "bulk-create-prospects",
        async lazy() {
          const { BulkCreateAeoProspects } = await import(
            "./bulk-create-aeo-prospects"
          );
          return { Component: BulkCreateAeoProspects };
        },
      },
    ],
  },
];
